export const ACTIONS = {
  STEP: "step",
  UPDATE_FORM: "update_form",
  RESET: "reset",
  ERROR: "error",
}

export const STEPS = {
  AMOUNT: "Donation",
  DETAILS: "Details",
  ADDRESS: "Address",
  CONFIRM: "Confirmation",
}

export const initialValue = {
  currentStep: STEPS.AMOUNT,
  form: {},
  project: {},
  error: null,
}

export const donationReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case ACTIONS.STEP: {
      return {
        ...state,
        currentStep: action.payload,
      }
    }

    case ACTIONS.UPDATE_FORM:
      return {
        ...state,
        form: {
          ...state.form,
          ...action.payload,
        },
      }
    case ACTIONS.RESET:
      return initialValue
    default:
      return state
  }
}
